/* =====================================================================
   17 NUTRITION – LEVERTIJD IN DE ZIJWINKELWAGEN (28-09-2026)
   Toont "Nu besteld, <datum> in huis!" onder de knop Afrekenen, op alle
   pagina's. De datum komt uit de bestaande levertimer (sectie
   midevv-delivery-timer), dus dezelfde regels als de sticky koopbalk:
   - op productpagina's: uit <midevv-delivery-data> op de pagina;
   - elders: via de Section Rendering API van een vaste productpagina.
   Geen data = geen regel (nooit een verkeerde datum tonen).
   ===================================================================== */
(function () {
  if (window.n17CartDelivery) return;
  window.n17CartDelivery = true;

  var REF_URL = '/products/creatine-monohydraat-micronized-zak';
  var REF_SECTION = 'template--32232958329157__midevv_delivery_timer_RWYVXW';
  var TTL = 10 * 60 * 1000; // 10 minuten
  var country = (window.Shopify && Shopify.country) || '';
  var CACHE_KEY = 'n17-levertijd-' + country;
  var TRUCK = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 17h4V5H2v12h3"></path><path d="M20 17h2v-3.34a4 4 0 0 0-1.17-2.83L19 9h-5"></path><path d="M14 17h1"></path><circle cx="7.5" cy="17.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle><path d="M2 9h4"></path><path d="M2 13h2"></path></svg>';

  var data = null;

  function readEl(el) {
    if (!el || !el.dataset || !el.dataset.formatted) return null;
    var d = el.dataset;
    return {
      isTomorrow: d.isTomorrow === 'true',
      minWeekday: d.minWeekday,
      formatted: d.formatted,
      prefix: d.stickyPrefix || 'Nu besteld,',
      tomorrow: d.stickyTomorrow || 'morgen in huis!',
      saturday: d.stickySaturday || 'zaterdag in huis!',
      suffix: d.stickySuffix || 'in huis!',
      compact: d.stickyCompact !== 'false'
    };
  }

  function textFor(d) {
    var pre = d.prefix ? d.prefix + ' ' : '';
    if (!d.compact) return pre + '<strong>' + d.formatted + '</strong>';
    if (d.isTomorrow) return pre + '<strong>' + d.tomorrow + '</strong>';
    if (d.minWeekday === '6') return pre + '<strong>' + d.saturday + '</strong>';
    return pre + '<strong>' + d.formatted + ' ' + d.suffix + '</strong>';
  }

  function fromCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < TTL) return c.d;
    } catch (e) {}
    return null;
  }

  function toCache(d) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
  }

  function load() {
    var local = readEl(document.querySelector('midevv-delivery-data'));
    if (local) { toCache(local); return Promise.resolve(local); }
    var cached = fromCache();
    if (cached) return Promise.resolve(cached);
    return fetch(REF_URL + '?sections=' + REF_SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j[REF_SECTION]) return null;
        var tmp = document.createElement('div');
        tmp.innerHTML = j[REF_SECTION];
        var d = readEl(tmp.querySelector('midevv-delivery-data'));
        if (d) toCache(d);
        return d;
      })
      .catch(function () { return null; });
  }

  function render() {
    if (!data) return;
    var footer = document.querySelector('.mini-cart__drawer-footer');
    if (!footer) return;
    var btn = footer.querySelector('.checkout-button');
    if (!btn) return;
    var line = footer.querySelector('.n17-cart-delivery');
    var text = textFor(data);
    if (!line) {
      line = document.createElement('div');
      line.className = 'n17-cart-delivery';
      btn.insertAdjacentElement('afterend', line);
    }
    // alleen schrijven als de tekst verandert (voorkomt een lus met de MutationObserver)
    if (line.getAttribute('data-text') !== text) {
      line.setAttribute('data-text', text);
      line.innerHTML = TRUCK + '<span>' + text + '</span>';
    }
  }

  function start() {
    load().then(function (d) {
      data = d;
      render();
      // De zijwinkelwagen wordt na elke wijziging opnieuw opgebouwd
      new MutationObserver(function () { render(); })
        .observe(document.body, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* =====================================================================
   17 NUTRITION – WINKELREVIEWS IN DE ZIJWINKELWAGEN (07-10-2026)
   Zet bovenaan de footer van de zijwinkelwagen: exacte sterren +
   "4,8/5 · 801 winkelbeoordelingen" (Judge.me, shop-metavelden).
   HTML komt uit sections/17n-review-score.liquid (Section Rendering API),
   30 min bewaard in sessionStorage per taal. Geen data = geen regel.
   ===================================================================== */
(function () {
  if (window.n17CartReviews) return;
  window.n17CartReviews = true;

  var SECTION = '17n-review-score';
  var TTL = 30 * 60 * 1000;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CACHE_KEY = 'n17-reviewscore-' + root;
  var html = null;

  function fromCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < TTL) return c.h;
    } catch (e) {}
    return null;
  }

  function load() {
    var cached = fromCache();
    if (cached !== null) return Promise.resolve(cached);
    return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j[SECTION]) return '';
        var tmp = document.createElement('div');
        tmp.innerHTML = j[SECTION];
        var el = tmp.querySelector('.n17-score');
        var style = tmp.querySelector('style');
        var h = el ? el.outerHTML + (style ? style.outerHTML : '') : '';
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), h: h })); } catch (e) {}
        return h;
      })
      .catch(function () { return ''; });
  }

  function render() {
    if (!html) return;
    var footer = document.querySelector('.mini-cart__drawer-footer');
    if (!footer || footer.querySelector('.n17-cart-reviews')) return;
    var wrap = document.createElement('div');
    wrap.className = 'n17-cart-reviews';
    wrap.innerHTML = html;
    footer.insertAdjacentElement('afterbegin', wrap);
  }

  function start() {
    load().then(function (h) {
      html = h;
      render();
      new MutationObserver(function () { render(); })
        .observe(document.body, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();